import { lazy } from 'react'

export const AboutFeelingGoodV1 = lazy(() => import('./AboutFeelingGoodV1'))
